import { Box, Paper, Typography } from "@mui/material";

interface Props {
	total: number;
}

export const NewRollsSummary = ({ total }: Props) => {
	return (
		<Paper elevation={1} sx={{ px: 2, py: 0.75 }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 4,
					flexWrap: "wrap",
				}}
			>
				<Typography variant="body2">
					<strong>Total:</strong> {total} roll{total === 1 ? "" : "s"}
				</Typography>
			</Box>
		</Paper>
	);
};
